import PuzzleService from '_services/rest/modules/puzzle-term';

export default {
  state: {
    puzzle: null,
    puzzleList: null,
  },
  mutations: {
    setPuzzleTermList(state, response) {
      state.puzzleList = response;
    },
    setPuzzleTerm(state, puzzle) {
      state.puzzle = puzzle;
    },
  },
  actions: {
    getPuzzleTerm({ commit }, id) {
      PuzzleService.getPuzzleById(id)
        .then(response => {
          commit('setPuzzleTerm', response);
        });
    },
    getPuzzleTermList({ commit }, params) {
      PuzzleService.getPuzzles(params)
        .then(response => {
          commit('setPuzzleTermList', response);
        });
    },
  },
};
